import router from '@/router'
import { getToken } from '@/util/getToken'
import axios from 'axios' //引入
import { Message, MessageBox } from 'element-ui'
// 创建axios实例
const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  baseURL: process.env.VUE_APP_BASE_API,
  // 超时
  timeout: 120000,
})

/* 请求拦截器（请求之前的操作） */
service.interceptors.request.use(
  (config) => {
    // 是否需要设置 token
    const isToken = config.headers?.isToken === false
    if (getToken() && !isToken) {
      config.headers['Authorization'] = 'Bearer ' + getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
    }
    return config
  },
  (err) => Promise.reject(err)
)

// 响应拦截器
service.interceptors.response.use(
  async (res) => {
    let data = res.data
    if (data instanceof Blob && data.type == 'application/json') {
      data = await blobJsonHandle(data)
    }
    if (data.code == 200) {
      return data
    }
    if (data.code == 401) {
      if (window.self !== window.top) {
        window.parent.postMessage({ type: 'lossToken' }, process.env.VUE_APP_EDU_MESSAGE_URL)
        return
      }
      if (!sessionStorage.getItem('tokenExpired')) {
        MessageBox.alert('登陆信息已失效，请重新登录。', '提醒', {
          confirmButtonText: '确定',
          showClose: false,
          center: true,
          callback: () => {
            sessionStorage.removeItem('tokenExpired')
            router.push('./login')
          },
        })
        sessionStorage.setItem('tokenExpired', true)
        return Promise.reject(new Error('登录失效,' + JSON.stringify(res)))
      } else {
        return
      }
    }
    if (data.code == 402) {
      if (window.self !== window.top) {
        window.parent.postMessage({ type: 'otherLogin' }, process.env.VUE_APP_EDU_MESSAGE_URL)
        return
      }
      if (!sessionStorage.getItem('tokenExpired')) {
        MessageBox.alert('账号已在其他地方登录,如果非本人操作,请尽快修改账号密码!', '异常登录', {
          type: 'info',
          callback: () => {
            router.push('./login')
            sessionStorage.removeItem('tokenExpired')
          },
        })
        sessionStorage.setItem('tokenExpired', true)
        return Promise.reject(new Error('异常登录,' + JSON.stringify(res)))
      }
    }
    Message.error(data.message)
    return Promise.reject(new Error(data?.message || '未知错误'))
  },
  (error) => {
    return Promise.reject(error)
  }
)

async function blobJsonHandle(blob) {
  let result = await blob.text()
  return JSON.parse(result)
}

export default service
